package navigation.home.messages

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.message.domain.repository.ConversationRepository
import com.essntl.features.message.domain.repository.MessageRepository
import com.essntl.features.message.ui.chat.ChatEvent
import com.essntl.features.message.ui.chat.ChatState
import com.essntl.features.message.ui.chat.ChatViewModel
import com.essntl.features.notification.domain.repository.NotificationRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository

class ChatScreenModel(
    messageRepository: MessageRepository,
    notificationRepository: NotificationRepository,
    conversationRepository: ConversationRepository,
    clientRepository: ClientRepository,
    supplierRepository: SupplierRepository,
    travelAgentRepository: TravelAgentRepository,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<ChatState>(ChatState()) {

    private val vm = ChatViewModel(
        messageRepository = messageRepository,
        notificationRepository = notificationRepository,
        conversationRepository = conversationRepository,
        clientRepository = clientRepository,
        supplierRepository = supplierRepository,
        travelAgentRepository = travelAgentRepository,
        getCurrentUserUseCase = getCurrentUserUseCase,
        scope = screenModelScope,
        state = mutableState,
        loadingManager = loadingManager,
    )

    fun onEvent(event: ChatEvent) = vm.onEvent(event)
}